import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';
import { ReactComponent as DownloadOfflineSvg } from './downloadoffline.svg';

const DownloadOfflineIcon = (props: SvgIconProps) => (
  <SvgIcon component={DownloadOfflineSvg} inheritViewBox {...props} />
);

export default DownloadOfflineIcon;
